/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alert_Fancy_Dachshund_ProsperInputs */

const fr_alert_fancy_dachshund_prosper = /** @type {(inputs: Alert_Fancy_Dachshund_ProsperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editer la séance`)
};

/**

* @param {Alert_Fancy_Dachshund_ProsperInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const alert_fancy_dachshund_prosper = /** @type {((inputs?: Alert_Fancy_Dachshund_ProsperInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alert_Fancy_Dachshund_ProsperInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_alert_fancy_dachshund_prosper(inputs)
});